module.exports = __webpack_public_path__ + "assets/img/D-572947d5.jpg";